import axios from 'axios';

// Create axios instance with default config
const api = axios.create({
  // We don't need to specify the full URL with port, as the Vue proxy will handle this
  baseURL: '', 
  timeout: 15000,
  withCredentials: true, // Important for cookies/sessions
});

// Request interceptor
api.interceptors.request.use(
  config => {
    // Log complete URL for debugging
    console.log(`📡 API Request: ${config.method.toUpperCase()} ${config.url}`);
    return config;
  },
  error => {
    console.error('❌ API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('❌ API Response Error:', error.message);
    if (error.response) {
      console.log('Status:', error.response.status);
      console.log('Data:', error.response.data);
    }
    return Promise.reject(error);
  }
);

export default api; 